<template>
  <v-dialog v-model="showNewAppointment" width="1200" persistent>
    <v-card>
      <div id="holder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Reserve NBN Appointment</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <p class="white--text"></p>
          </v-col>
        </v-row>
      </v-banner>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text class="pt-0">
          <v-divider class="mt-4 mb-8"></v-divider>
          <nbn-appointment-details
            ref="nbnAppointmentDetails"
            :appointment="appointment"
            :businessOptionEnabled="businessOptionEnabled"
            @isQueried="isQueried"
          ></nbn-appointment-details>
        </v-card-text>

        <nbn-appointment-results
          ref="appointmentResults"
        ></nbn-appointment-results>

        <div class="text-right fixed-bar rtl primary py-4">
          <v-btn @click="close()" class="mr-4">Close</v-btn>
          <v-btn
            v-if="queried"
            class="mr-3"
            @click="submit"
          >Submit</v-btn
          >
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import NbnAppointmentDetails from "./nbn-appointment-details";
export default {
  name: "reserve-nbn-appointment",
  components: {NbnAppointmentDetails},
  props: {
    showNewAppointment: { type: Boolean, required: true },
    businessOptionEnabled: { type: Boolean, required: true }
  },
  data: () => ({
    appointment:{},
    queried : false
  }),
  methods:{
    close(appointmentID = null) {
      let vm = this;
      document.getElementById("holder").scrollIntoView({ behavior: "smooth" });
      vm.$refs.observer.reset();
      vm.$emit("close" ,appointmentID);
    },
    isQueried(){
      let vm = this;
      vm.queried = true;
    },
    submit() {
      let vm = this;
      let payload = {};

      payload = {appointment:{
        // externalId:"ABC-123",//todo need to replace this
        externalId: vm.nbnOrder.customerAuthRef,
        place:{id:vm.appointment.locationID},
        demandType:vm.appointment.demandType.value?vm.appointment.demandType.value:vm.appointment.demandType,
        endUserType:(vm.appointment.endUserType === null || vm.appointment.endUserType === undefined || vm.appointment.endUserType ==="")?"Residential":vm.appointment.endUserType.value,
        priorityAssist:"No",
        appointmentType:"Appointment",
        endUserContact:[{
          contactType:"Primary Contact",
          contactName:vm.appointment.contactName,
          phoneNumber:vm.appointment.phoneNumber,
          notes:vm.appointment.notes
        }],
        appointmentSlot:{
          appointmentSlotType:vm.appointment.appointmentSlotType.value?vm.appointment.appointmentSlotType.value:vm.appointment.appointmentSlotType,
          validFor:{
            startDateTime:vm.appointment.dateGroup.validFor.startDateTime,
            endDateTime:vm.appointment.dateGroup.validFor.endDateTime,
          }
        },
        siteAccess:{
          specialConditions:vm.appointment.siteAccessSpecialConditions,
          notes:vm.appointment.siteAccessNotes
        }
      }};

      if(payload.appointment.demandType !== "Service Restoration")
      {
        payload.appointment.appointmentSLA = vm.appointment.appointmentSla.value?vm.appointment.appointmentSla.value:vm.appointment.appointmentSla;
      } else {
        payload.appointment.serviceRestorationSLA = "Standard";
      }

      if(vm.appointment.cpiId != null)
      {
        payload.appointment.relatedEntity = [
          {
            id:vm.appointment.cpiId.value,
            "@referredType":"CopperPath"
          }
        ];
      }


      vm.createNbnAppointment(payload).then((data) => {
        vm.$refs.appointmentResults.showAppointmentResult = true;
        vm.$refs.appointmentResults.result = data;
        this.close(data.data.id)
      });
    }
  }
}
</script>

<style scoped>

</style>
